export default __webpack_public_path__ + "static/media/work-2left-2.b875fe79.png";